<script setup lang="ts">
import { provide } from 'vue'
import { useLayoutStore } from '@/Stores/layout'
import Notification from '@/Components/Utils/Notification.vue'
import { faCheck, faTruck, faPrint, faPencilRuler, faHourglassStart, faTimes, faLink } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faCheck, faTruck, faPrint, faPencilRuler, faHourglassStart, faTimes, faLink)

provide('layout', useLayoutStore())
</script>

<template>
    <div class="min-h-screen bg-gray-100 py-6">
        <main class="mx-auto max-w-3xl px-4">
            <slot />
        </main>
    </div>

    <notifications dangerously-set-inner-html :max="3" width="500" classes="custom-style-notification" :pauseOnHover="true">
        <template #body="props">
            <Notification :notification="props" />
        </template>
    </notifications>
</template>
